import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import TitleUnderlinedAnimated from "../TitleUnderlinedAnimated/index.jsx";
import {H1, H2, H3, H4} from "../semanticWrappers/index.jsx";
import {Text} from "../text/index.js";
import {
  MarkdownA,
  MarkdownBulletsList,
  MarkdownH5,
  MarkdownOrderedList,
  MarkdownP,
  MarkdownTable,
  MarkdownTd,
  MarkdownTh,
  ScrollableTableWrapper,
} from "./styles.js";

function Markdown({
  children,
  styles,
  h2Styles,
  h3Styles,
  linkStyles,
  wrapperStyles,
  textStyles,
  lineClamp,
}) {
  const components = {
    p: ({node, ...props}) => <MarkdownP {...props} style={{...styles, ...textStyles}} />,
    ul: ({node, ...props}) => <MarkdownBulletsList styles={styles} {...props} />,
    ol: ({node, ...props}) => <MarkdownOrderedList {...props} styles={styles} />,
    h5: ({node, ...props}) => <MarkdownH5 styles={styles} {...props} />,
    h4: ({node, ...props}) => <H4 styles={styles} {...props} />,
    h3: ({node, ...props}) => (
      <Text
        as={"h3"}
        {...props}
        type="titleExtraSmall"
        styles={{...styles, ...h3Styles}}
      />
    ),
    h2: ({node, ...props}) => (
      <TitleUnderlinedAnimated
        wrapperStyles={wrapperStyles}
        styles={{...styles, ...h2Styles}}
        {...props}
      />
    ),
    h1: ({node, ...props}) => <H1 styles={styles} {...props} />,
    a: ({node, ...props}) => <MarkdownA style={{...styles, ...linkStyles}} {...props} />,
    table: ({node, ...props}) => (
      <ScrollableTableWrapper>
        <MarkdownTable {...props} />
      </ScrollableTableWrapper>
    ),
    th: ({node, ...props}) => <MarkdownTh {...props} />,
    td: ({node, ...props}) => <MarkdownTd {...props} />,
  };

  return (
    <div
      style={{
        display: "inline",
        ...(lineClamp && {
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: lineClamp,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "normal",
        }),
      }}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw]}
        components={components}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}

export default Markdown;
